import { render, staticRenderFns } from "./DmTransactionRow.vue?vue&type=template&id=900f946e&scoped=true&"
import script from "./DmTransactionRow.vue?vue&type=script&lang=js&"
export * from "./DmTransactionRow.vue?vue&type=script&lang=js&"
import style0 from "./DmTransactionRow.vue?vue&type=style&index=0&id=900f946e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900f946e",
  null
  
)

export default component.exports